import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { pilotCards } from '../mock';
import { Card, CardContent } from './ui/card';
import { ArrowRight, PhoneCall } from 'lucide-react';

const PilotProgram = () => {
  const { t } = useLanguage();

  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="pilot" className="py-20 medical-section-bg" style={{ backgroundImage: `url(https://images.unsplash.com/photo-1688588161761-5617657f728f)` }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-4" style={{ color: '#2D4A8F' }}>
            {t.pilot.title}
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            {t.pilot.subtitle}
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {t.pilot.cards.map((card, index) => (
            <Card 
              key={index}
              className="card-hover border-none shadow-lg overflow-hidden"
              style={{ animationDelay: `${index * 0.1}s`, borderRadius: '16px' }}
            >
              <CardContent className="p-0">
                <div className="h-48 overflow-hidden">
                  <img 
                    src={pilotCards[index].image}
                    alt={card.title}
                    className="w-full h-full object-cover hover:scale-110 transition-transform duration-300"
                  />
                </div>
                <div className="p-6 space-y-4">
                  <h3 className="text-lg font-bold" style={{ color: '#2D4A8F' }}>
                    {card.title}
                  </h3>
                  <p className="text-gray-600 text-sm leading-relaxed">
                    {card.description}
                  </p>
                  <button 
                    onClick={scrollToContact}
                    className="w-full py-3 rounded-lg text-white font-semibold flex items-center justify-center space-x-2 hover:opacity-90"
                    style={{ backgroundColor: '#2D4A8F' }}
                  >
                    <span>{card.button}</span>
                    <ArrowRight size={18} />
                  </button>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="flex flex-col sm:flex-row justify-center gap-4">
          <button 
            onClick={scrollToContact}
            className="px-8 py-4 rounded-lg text-white font-semibold text-lg shadow-lg hover:opacity-90 transition-all"
            style={{ backgroundColor: '#2D4A8F' }}
          >
            {t.pilot.ctaPrimary}
          </button>
          <button 
            onClick={scrollToContact}
            className="px-8 py-4 rounded-lg font-semibold text-lg flex items-center justify-center space-x-2 border-2 bg-white hover:bg-gray-50 transition-colors"
            style={{ borderColor: '#2D4A8F', color: '#2D4A8F' }}
          >
            <PhoneCall size={20} />
            <span>{t.pilot.ctaSecondary}</span>
          </button>
        </div>
      </div>
    </section>
  );
};

export default PilotProgram;